<template>
  <div
    class="content-body"
  >
    <div class="content-body__title">
      {{$t('expiry-modals.sessionTimeout')}}

    </div>
    <div class="content-body__text">
      {{$t('expiry-modals.sessionExpiredNewUser')}}
    <!-- You have been inactive for a while. For your security,
    we have logged you out. Please click OK to continue. -->
    </div>

    <div class="content-body__button-box">
      <button
        @click="generateNewToken"
        class="content-body__button"
      >
        {{$t('expiry-modals.ok')}}
      </button>
    </div>
    <!-- eslint-disable-next-line-->
    <component is="style" scoped>
      :root {
      --button-default-background-color:{{ defaultButtonBackgroundColor() }};
      --button-default-text-color:{{ defaultButtonTextColor() }};
      }
    </component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { GENERATE_TOKEN_NEW_USER } from '../../store/modules/auth/consts';
import { routeEnum } from '../../store/modules/auth/enum';

export default {
  props: {
    marginTop: Boolean,
  },
  computed: {
    ...mapGetters({

      sessionNotifyStatus: 'user/sessionNotifyStatus',

    }),
  },
  methods: {
    async generateNewToken() {
      const { sessionNotifyStatus } = this;

      const result = await this.$store.dispatch(`auth/${GENERATE_TOKEN_NEW_USER}`, {
        encryptedReq: this.encryptStringWithRSA(JSON.stringify(
          { email: sessionNotifyStatus.data.email },
        )),
      });
      this.$store.commit(
        'user/setSessionNotifyStatus',
        { active: false },
      );
      if (result) {
        this.$emit('force-rerender', true);
      } else {
        this.$router.push({ name: routeEnum.SIGN_IN });
      }
    },
    defaultButtonBackgroundColor() {
      if (
        this.marketInfo
        && this.marketInfo.whiteLabel
        && this.marketInfo.whiteLabel.colorSchema
        && this.marketInfo.whiteLabel.colorSchema.colors
        && this.marketInfo.whiteLabel.colorSchema.colors.some((el) => el.name === 'Button')
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find((el) => el.name === 'Button');
        const child = section.children.find((el) => el.name === 'Default');
        const property = child.properties.find((el) => el.name === 'Background Color');
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return '#f0833c';
    },
    defaultButtonTextColor() {
      if (
        this.marketInfo
        && this.marketInfo.whiteLabel
        && this.marketInfo.whiteLabel.colorSchema
        && this.marketInfo.whiteLabel.colorSchema.colors
        && this.marketInfo.whiteLabel.colorSchema.colors.some((el) => el.name === 'Button')
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find((el) => el.name === 'Button');
        const child = section.children.find((el) => el.name === 'Default');
        const property = child.properties.find((el) => el.name === 'Text Color');
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return '#ffffff';
    },
  },
};
</script>
<style lang="scss" scoped>
.content-body{
  width: 70%;
  min-height: 180px;

  margin: auto;
  z-index: 750;
  background-color: #fff;
  padding: 20px;
  &__title{
        text-align: center;
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: bold;
  }
  &__text{
        text-align: center;
    font-size: 14px;
  }
  &__button-box{
    display: flex;
    justify-content: center;
  }
  &__button{
    background-color: var(--button-default-background-color);
    margin-top: 20px;
    width: 80px;
    color:var(--button-default-text-color);
    font-size: 15px;
  }
}

</style>
